import React, { useState,useContext} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SignInSideImg from "../../Assets/SignPageImg.jpg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AccessHub from "../../Assets/access-hub-logo.png";
import axios from "../../customAxios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { AuthContext } from '../../AuthProvider';

const SignInPage = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const{ authenticated,login,logout } = useContext(AuthContext)

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId || !password) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill in all fields.",
      });
      return;
    }

    console.log("registeredAppName:",process.env.REACT_APP_REGISTERED_APP_NAME);

    const payload = {
      requestToken: {
        registeredAppName: process.env.REACT_APP_REGISTERED_APP_NAME,
        userid: userId,
        password: password,
      },
    };

    try {
      const response = await axios.post(
        "/RequestJWTToken/TokenProvider/requestToken",
        payload
      );
console.log(response);
      if (response.data.status === "success") {
        const accessToken = response.data.tokenResponse.accessToken;
        Cookies.set("accessToken", accessToken, { expires: 7 }); 
        login()

        Swal.fire({
          icon: "success",
          title: "Success",
          timer:1500,
          text: "You have signed in successfully! Redirecting...",
          showConfirmButton:false
        });

        // Redirect after a short delay
        setTimeout(() => {
          navigate("/application/manage-app-content");
        }, 1500);
      } else {
        throw new Error("Failed to authenticate");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Invalid credentials. Please try again.",
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Left Section */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          position: "relative",
        }}
      >
        <img
          src={AccessHub}
          alt="Logo"
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            height: "50px",
            objectFit: "contain",
          }}
        />
        <div style={{ width: "400px" }}>
          <h1 style={{ marginBottom: "20px" }}>Sign In</h1>
          <form
            onSubmit={handleSubmit}
            style={{
              width: "100%",
              maxWidth: "400px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TextField
              label="User Id"
              variant="outlined"
              fullWidth
              margin="normal"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Link
              style={{
                margin: "10px 0px",
                color: "var(--primary-color)",
              }}
              className="forget-password-link"
            >
              Forget Password
            </Link>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              style={{
                marginTop: "10px",
                backgroundColor: "var(--primary-color)",
                color: "#fff",
                borderRadius: "7px",
                padding: "10px ",
              }}
            >
              Sign In
            </Button>
          </form>
        </div>
      </div>

      {/* Right Section */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          src={SignInSideImg}
          alt="Sign In"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  );
};

export default SignInPage;
